import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056f052b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "frisbuy-customer-review__play-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.9748 13.7289C24.6669 14.7701 24.6669 17.2297 22.9748 18.271L13.3963 24.1655C11.6196 25.2589 9.33203 23.9806 9.33203 21.8944L9.33203 10.1054C9.33203 8.01926 11.6196 6.74099 13.3963 7.83436L22.9748 13.7289Z",
    fill: "white"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "frisbuy-customer-review__media-list-item-hover-count"
}
const _hoisted_7 = { class: "frisbuy-customer-review__media-list-item-hover-count-text" }

import { computed, onMounted, nextTick } from "vue";
import { Property } from "csstype";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { imageWithPostId } from "@/widgets/MarketplaceReviews/interfaces";

export type MediaListCustomization = {
  wrap?: Property.FlexWrap;
  gap?: Property.Gap;
  mediaWidth?: Property.Width;
  mediaHeight?: Property.Height;
  maxMediaItems?: number;
  isShowCountBlock?: boolean;
  isShowCountHover?: boolean;
  mediaAspectRatio?: Property.AspectRatio;
  totalMediaCount?: number;
};

const errorImagePlug = "https://www.frisbuy.ru/images/empty_media.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaList',
  props: {
    mediaList: {},
    wrap: { default: "nowrap" },
    gap: { default: "8px" },
    mediaWidth: { default: "80px" },
    mediaHeight: { default: "unset" },
    maxMediaItems: { default: 6 },
    isShowCountBlock: { type: Boolean, default: false },
    isShowCountHover: { type: Boolean, default: false },
    mediaAspectRatio: { default: "1 / 1" },
    totalMediaCount: {}
  },
  emits: ["selectMedia"],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;

const hiddenMediaCount = computed(() => {
  const totalMediaCount = props.totalMediaCount ?? props.mediaList.length;
  return Math.max(totalMediaCount - props.maxMediaItems, 0);
});

const emit = __emit;

function selectMedia(media: imageWithPostId) {
  emit("selectMedia", media);
}

// Safari fix for video height issue
function fixSafariVideoHeight() {
  if (
    typeof window !== "undefined" &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent)
  ) {
    nextTick(() => {
      const mediaItems = document.querySelectorAll(
        ".frisbuy-customer-review__media-list-item"
      );
      mediaItems.forEach((item: Element) => {
        const htmlItem = item as HTMLElement;
        // Force reflow by toggling display
        const originalDisplay = htmlItem.style.display;
        htmlItem.style.display = "none";
        htmlItem.offsetHeight; // Force reflow
        htmlItem.style.display = originalDisplay || "flex";
      });
    });
  }
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

onMounted(() => {
  fixSafariVideoHeight();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: "frisbuy-customer-review__media-list",
    style: _normalizeStyle({
      flexWrap: props.wrap,
      gap: props.gap,
    })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaList.slice(0, props.maxMediaItems), (media, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: idx,
        class: "frisbuy-customer-review__media-list-item",
        style: _normalizeStyle({
        backgroundImage: `url(${_unref(DomainSubstitute)(
          media.thumbnailUrl
        )}), url(${errorImagePlug})`,
        width: props.mediaWidth,
        height: props.mediaHeight,
        aspectRatio: props.mediaAspectRatio,
      }),
        onClick: _withModifiers(() => selectMedia(media), ["stop"])
      }, [
        _createElementVNode("img", {
          class: "frisbuy-customer-review__media-image",
          src: _unref(DomainSubstitute)(media.thumbnailUrl),
          onError: errorImageHandler
        }, null, 40, _hoisted_2),
        (
          media.videoUrl.length > 0 &&
          !(
            props.isShowCountHover &&
            idx + 1 === props.maxMediaItems &&
            hiddenMediaCount.value > 0
          )
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        (
          props.isShowCountHover &&
          idx + 1 === props.maxMediaItems &&
          hiddenMediaCount.value > 0
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, " +" + _toDisplayString(hiddenMediaCount.value), 1)
            ]))
          : _createCommentVNode("", true)
      ], 12, _hoisted_1))
    }), 128)),
    (props.isShowCountBlock && hiddenMediaCount.value > 0)
      ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          class: "frisbuy-customer-review__media-list-item-counter-block",
          style: _normalizeStyle({
        width: props.mediaWidth,
        height: props.mediaHeight,
        aspectRatio: props.mediaAspectRatio,
      }),
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => selectMedia(props.mediaList[props.maxMediaItems + 1]), ["stop"]))
        }, " +" + _toDisplayString(hiddenMediaCount.value), 5))
      : _createCommentVNode("", true)
  ], 4))
}
}

})